import React, { useRef, useState, useEffect } from 'react';
import { Box, Grid, Button } from "@mui/material";
import { Bar } from 'react-chartjs-2';
import { SwiperSlide, Swiper } from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";
import MissingTopics from "./missingtopics";
import axios from 'axios';
import { BASELINE } from '../../../util';
import OverallSATAnal from './OverallSATANAL';
import CountUp from 'react-countup';
import ModalComponent from "../pick_modal";
import PromotionModal from '../../../Components/popmodal';
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import { ArrowRight, BookOpen, Calculator } from 'lucide-react';

const DigitalSatView = ({
    lastTest,
    laste,
    lastm,
    allSATScores,
    Incorrect_questionIds,
    Correct_questionIds = [],
    user,
    setaiquestion,
    setmocksatreview,
    setsatanal,
    setdashboard
}) => {
    const topEngTopics = findTopMissedTopics(Incorrect_questionIds, Correct_questionIds, "eng");
    const topMathTopics = findTopMissedTopics(Incorrect_questionIds, Correct_questionIds, "math");
    const [topic, settopic] = useState(false);
    const [section, setsection] = useState("");
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [infoMessage, setInfoMessage] = useState("");
    const [noTestsTaken, setNoTestsTaken] = useState(false);

    const navigate = useNavigate();

    const [scores, setScores] = useState([
        { name: "SAT 1", myScore: 0, avgScore: 1000, section: "" },
        { name: "SAT 2", myScore: 0, avgScore: 1000, section: "" },
        { name: "SAT 3", myScore: 0, avgScore: 1000, section: "" },
        { name: "SAT 4", myScore: 0, avgScore: 1000, section: "" },
        { name: "SAT 5", myScore: 0, avgScore: 1000, section: "" },
        { name: "SAT 6", myScore: 0, avgScore: 1000, section: "" },
    ]);

    const getting_problems = () => {
        axios.get(`${BASELINE}tests/byuser/${user.u_id}`)
            .then(response => {
                if (!response.data || response.data.length === 0) {
                    setNoTestsTaken(true);
                } else {
                    setNoTestsTaken(false);
                }
            })
            .catch(error => {
                console.error("Error fetching user tests:", error);
            });
    };

    useEffect(() => {
        getallsat();
        getusersat();
        getting_problems();
    }, []);

    const updateScoresWithApiData = (apiData) => {

        setScores(prevScores => {
            const apiScoresMap = apiData.reduce((acc, item) => {

                acc[item.test_name] = {
                    total_score: item.total_score,
                    section_data: item.section_data
                };
                return acc;
            }, {});


            const updatedScores = prevScores.map(score => {
                const updatedScore = {
                    ...score,
                    myScore: apiScoresMap[score.name]?.total_score || score.myScore,
                    section: apiScoresMap[score.name]?.section_data || score.section
                };
                return updatedScore;
            });

            return updatedScores;
        });
    };

    const getusersat = () => {
        axios.get(`${BASELINE}get/user/sat`, {
            params: { user_id: user.u_id }
        })
            .then(response => {
                updateScoresWithApiData(response.data);
            })
            .catch(err => {
                console.error("Error fetching user SAT data:", err);
            });
    };

    const handleRowClick = (subjectName, section) => {
        setsection(section);
        settopic(subjectName);
        setIsModalOpen2(true);
    };

    function findTopMissedTopics(incorrectData, correctData, tag) {
        const incorrectCount = {};
        const totalCount = {};

        incorrectData.forEach(item => {
            if (item.tag === tag) {
                incorrectCount[item.topic] = (incorrectCount[item.topic] || 0) + 1;
                totalCount[item.topic] = (totalCount[item.topic] || 0) + 1;
            }
        });

        correctData.forEach(item => {
            if (item.tag === tag) {
                totalCount[item.topic] = (totalCount[item.topic] || 0) + 1;
            }
        });

        const sortedTopics = Object.entries(incorrectCount).sort((a, b) => b[1] - a[1]);

        return sortedTopics.slice(0, 10).map(([topic, inc]) => ({
            topic,
            count: inc,
            total: totalCount[topic] || inc,
        }));
    }

    const getPerformanceLabel = (score) => {
        let label = "";
        let glowColor = "";

        if (score < 400) {
            label = "Need to Study";
            glowColor = "redGlow";  // Red glow
        } else if (score < 600) {
            label = "Need Review";
            glowColor = "orangeGlow";  // Orange glow
        } else {
            label = "Good Standing";
            glowColor = "greenGlow";  // Green glow
        }

        return { label, glowColor };
    };

    const set_aiQuestion = () => {
        if (user?.premium === 1) {
            setsatanal(`
                System: You are a JSON-only response AI analyzer. You must respond with ONLY a valid JSON object, no additional text or explanations.
                
                Input Data:
                - Latest SAT score: ${lastTest}/1600
                - English score: ${laste} (Standing: ${getPerformanceLabel(laste).label})
                - Math score: ${lastm} (Standing: ${getPerformanceLabel(lastm).label})
                
                Required JSON Structure:
                {
                  "Recent SAT Trend": {
                    "Grade": "[A-F]",
                    "Reason": "[Analysis with **bold** formatting]"
                  },
                  "Score Review": {
                    "Grade": "[A-F]",
                    "Reason": "[Details with **bold** formatting]"
                  },
                  "Study Pathway": {
                    "Grade": "[A-F]",
                    "Reason": "[Recommendations with **bold** formatting]"
                  },
                  "College Rank": {
                    "Grade": "[A-F]",
                    "Reason": "[College suggestions with **bold** formatting]"
                  }
                }
                
                Rules:
                1. Response must be a valid JSON object
                2. Use markdown-style bold formatting with ** for emphasis
                3. No text outside the JSON structure
                4. No trailing commas
                5. Use double quotes for all strings
                6. Grades must be single letters: A, B, C, D, or F
                7. Maximum response length: 800 tokens
                `);
        } else {
            setModalOpen(true);
        }
    }

    const set_aiQuestion_graph = () => {
        if (user?.premium === 1) {
            setaiquestion(`
                System: You are a JSON-only response AI analyzer. You must respond with ONLY a valid JSON object, with no additional text or explanations.
                
                Input Data:
                - Current SAT Score: ${data.datasets[2].data.at(-1)}
                - Predicted SAT Score: ${data.datasets[1].data.slice(0, -1)}
                
                Required JSON Structure (response must exactly match this format):
                {
                  "studyTimeRequired": {
                    "months": [an integer between 1 and 12],
                    "detail": "[Study plan explanation with **bold** formatting]"
                  },
                  "achievabilityRate": {
                    "percentage": [an integer between 10 and 100],
                    "reason": "[Explanation with **bold** formatting]"
                  },
                  "furtherGrowthPotential": {
                    "percentage": [an integer between 10 and 100],
                    "explanation": "[Potential analysis with **bold** formatting]"
                  }
                }
                
                Rules:
                1. The response must be a valid JSON object that starts with "{" and ends with "}".
                2. Do not include any extra text, comments, or explanations outside the JSON structure.
                3. Use markdown-style bold formatting with ** inside string values.
                4. All numbers must be output as integers (without quotes).
                5. All keys and string values must be enclosed in double quotes.
                6. Percentages must be integers between 10 and 100.
                7. Study time (months) must be an integer between 1 and 12.
                8. The entire response must be ONLY the JSON object (no additional characters or text).
                9. Maximum response length: 800 tokens.
                `);

        } else {
            setModalOpen(true);
        }
    }

    const set_aiQuestion_scores = (score, avg, section) => {
        if (user?.premium === 1) {
            if (score === 0) {
                setmocksatreview("I haven't taken this SAT test yet. Please advice me to complete the test first to get a detailed analysis of your performance. NO DATA for this mock SAT.");
            } else {
                setmocksatreview(`
                    System: You are a JSON-only response analyzer. You must respond with ONLY a valid JSON object, no additional text, explanations, or markdown.
                    
                    Input Data:
                    - Student Score: ${score}
                    - Average Score: ${avg}
                    - Test Topics: ${section}
                    
                    Required JSON Structure:
                    {
                      "SAT difficulty": "Easy|Medium|Hard",
                      "MY SAT SCORE": {
                        "Letter grade": "A|B|C|D|F",
                        "Reason": "Brief explanation"
                      },
                      "English priority Topics": [
                        "topic1",
                        "topic2",
                        "topic3"
                      ],
                      "Math priority Topics": [
                        "topic1",
                        "topic2",
                        "topic3"
                      ],
                      "Performance analysis": "Overall analysis and recommendations"
                    }
                    
                    Rules:
                    1. Response must be a valid JSON object
                    2. No text outside the JSON structure
                    3. No trailing commas
                    4. Use double quotes for all strings
                    5. SAT difficulty rules:
                       - "Hard" if avg > 1300
                       - "Medium" if avg between 1000-1300
                       - "Easy" if avg < 1000
                    6. Letter grade rules:
                       - "A" if score > avg + 200
                       - "B" if score > avg + 100
                       - "C" if score within ±100 of avg
                       - "D" if score < avg - 100
                       - "F" if score < avg - 200
                    7. Topics must be specific and actionable
                    8. Maximum response length: 800 tokens
                    
                    IMPORTANT: Return ONLY the JSON object, nothing else.`);
            }
        } else {
            setModalOpen(true);
        }
    };

    const getallsat = () => {
        axios
            .get(`${BASELINE}get/all/sat`)
            .then(response => {
                const data = Array.isArray(response.data) ? response.data : [];

                // test_name별로 total_score 합산 후 average 계산
                const scoresMap = data.reduce((acc, item) => {
                    // item.test_name이 존재하고, total_score가 숫자인지 확인
                    if (item.test_name && typeof item.total_score === "number") {
                        // 비교시 공백 제거 및 소문자화 처리
                        const testNameKey = item.test_name.trim().toLowerCase();
                        if (!acc[testNameKey]) {
                            acc[testNameKey] = { total: 0, count: 0 };
                        }
                        acc[testNameKey].total += item.total_score;
                        acc[testNameKey].count += 1;
                    }
                    return acc;
                }, {});

                const averages = Object.keys(scoresMap).map(testKey => ({
                    // 평균 점수 계산
                    test_name: testKey,
                    avgScore: Math.round(scoresMap[testKey].total / scoresMap[testKey].count)
                }));

                // scores 업데이트: 이전 state를 기준으로 functional update 사용
                setScores(prevScores =>
                    prevScores.map(score => {
                        const scoreNameKey = score.name.trim().toLowerCase();
                        const averageData = averages.find(
                            avg => avg.test_name === scoreNameKey
                        );
                        return {
                            ...score,
                            avgScore: averageData ? averageData.avgScore : score.avgScore || 0,
                        };
                    })
                );
            })
            .catch(err => console.error("Error fetching SAT scores:", err));
    };

    const handleNext = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };

    const handlePrev = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    const swiperRef = useRef(null);
    const mobileSwiperRef = useRef(null);

    // AI 예측 점수를 계산하는 함수
    const computeAiPredictedScore = (scores) => {
        if (scores.length < 2) return null;
        const lastScore = scores[scores.length - 1];
        const prevScore = scores[scores.length - 2];
        return (lastScore + prevScore) / 2;
    };

    // 마지막 5개 항목만 선택
    const last5Scores = allSATScores.slice(-5);

    // 1. 기존 라벨 생성: 각 날짜를 "Mon'YY" 형식으로 포맷
    const originalLabels = last5Scores.map(item => {
        const date = new Date(item.date);
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear().toString().slice(-2);
        return `${month}'${year}`;
    });
    // 2. 실제 데이터 라벨에 "Predicted"라는 추가 라벨을 붙임
    const labels = [...originalLabels, "Predicted"];

    // 3. 실제 SAT 점수 배열 생성
    const currentScores = last5Scores.map(item => item.score);
    // 4. 실제 데이터셋에 예측 데이터 인덱스를 위해 null 추가
    const extendedCurrentScores = [...currentScores, null];

    // 5. AI 예측 점수 계산 (예: (400+600)/2 = 500)
    const aiPredictedScore = computeAiPredictedScore(currentScores);
    // 6. AI 예측 데이터셋 배열 생성. 전체 길이를 맞추고 마지막 인덱스에 예측값을 넣음.
    const aiPredictedData = new Array(extendedCurrentScores.length).fill(null);
    if (currentScores.length >= 2) {
        aiPredictedData[extendedCurrentScores.length - 1] = aiPredictedScore;
    }

    // Plugin to draw AI forecast label with arrow
    const aiLabelPlugin = {
        id: 'aiLabel',
        afterDraw(chart) {
            const { ctx, data: cd } = chart;
            cd.datasets.forEach((dataset, i) => {
                if (dataset.label !== 'AI Forecast') return;
                const meta = chart.getDatasetMeta(i);
                meta.data.forEach((point, idx) => {
                    const value = dataset.data[idx];
                    if (value === null || value === undefined) return;
                    const score = Math.round(value);
                    ctx.save();

                    const scoreText = `${score}`;
                    const labelText = 'AI Predicted';
                    ctx.font = 'bold 14px -apple-system, BlinkMacSystemFont, sans-serif';
                    const sw = ctx.measureText(scoreText).width;
                    ctx.font = '10px -apple-system, BlinkMacSystemFont, sans-serif';
                    const lw = ctx.measureText(labelText).width;
                    const pw = Math.max(sw, lw) + 24;
                    const ph = 46;
                    const px = point.x - pw / 2;
                    const py = point.y - ph - 16;

                    // Shadow
                    ctx.shadowColor = 'rgba(245,158,11,0.3)';
                    ctx.shadowBlur = 12;
                    ctx.shadowOffsetY = 4;

                    // Pill
                    ctx.fillStyle = '#fffbeb';
                    ctx.strokeStyle = '#fbbf24';
                    ctx.lineWidth = 1.5;
                    ctx.beginPath();
                    ctx.roundRect(px, py, pw, ph, 10);
                    ctx.fill();
                    ctx.stroke();

                    ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;

                    // Arrow
                    ctx.fillStyle = '#fbbf24';
                    ctx.beginPath();
                    ctx.moveTo(point.x - 7, py + ph);
                    ctx.lineTo(point.x + 7, py + ph);
                    ctx.lineTo(point.x, point.y - 6);
                    ctx.closePath();
                    ctx.fill();

                    // Label
                    ctx.font = '10px -apple-system, BlinkMacSystemFont, sans-serif';
                    ctx.fillStyle = '#92400e';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'top';
                    ctx.fillText(labelText, point.x, py + 8);

                    // Score
                    ctx.font = 'bold 15px -apple-system, BlinkMacSystemFont, sans-serif';
                    ctx.fillStyle = '#b45309';
                    ctx.fillText(scoreText, point.x, py + 22);

                    ctx.restore();
                });
            });
        }
    };

    // Glow plugin for futuristic line effect
    const glowPlugin = {
        id: 'glowLines',
        afterDraw(chart) {
            const { ctx, data: cd } = chart;
            cd.datasets.forEach((dataset, i) => {
                if (dataset.type !== 'line') return;
                const meta = chart.getDatasetMeta(i);
                const pts = meta.data.filter(p => p && p.x !== undefined && !isNaN(p.y));
                if (pts.length < 2) return;
                ctx.save();
                ctx.shadowColor = dataset.borderColor;
                ctx.shadowBlur = 18;
                ctx.strokeStyle = dataset.borderColor;
                ctx.lineWidth = (dataset.borderWidth || 2) + 0.5;
                ctx.globalAlpha = 0.55;
                if (dataset.borderDash) ctx.setLineDash(dataset.borderDash);
                ctx.beginPath();
                pts.forEach((p, idx) => idx === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y));
                ctx.stroke();
                ctx.restore();
            });
        }
    };

    // 7. Chart.js에 사용할 data 객체 구성
    const data = {
        labels: labels,
        datasets: [
            {
                type: "bar",
                label: "Score",
                data: extendedCurrentScores,
                backgroundColor: (context) => {
                    const { ctx, chartArea } = context.chart;
                    if (!chartArea) return 'rgba(219,234,254,0.8)';
                    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                    gradient.addColorStop(0, 'rgba(59,130,246,0.45)');
                    gradient.addColorStop(1, 'rgba(59,130,246,0.04)');
                    return gradient;
                },
                borderColor: 'rgba(59,130,246,0.5)',
                borderWidth: { top: 2, left: 0, right: 0, bottom: 0 },
                borderRadius: { topLeft: 6, topRight: 6 },
                borderSkipped: false,
                barPercentage: 0.45,
                categoryPercentage: 0.6,
                order: 2,
            },
            {
                type: "line",
                label: "Trend",
                data: extendedCurrentScores,
                borderColor: "#2563eb",
                borderWidth: 3,
                pointRadius: 5,
                pointBackgroundColor: "#2563eb",
                pointBorderColor: "#ffffff",
                pointBorderWidth: 2.5,
                pointHoverRadius: 8,
                tension: 0.4,
                fill: 'origin',
                backgroundColor: (context) => {
                    const { ctx, chartArea } = context.chart;
                    if (!chartArea) return 'rgba(37,99,235,0)';
                    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                    gradient.addColorStop(0, 'rgba(37,99,235,0.15)');
                    gradient.addColorStop(0.65, 'rgba(37,99,235,0.04)');
                    gradient.addColorStop(1, 'rgba(37,99,235,0)');
                    return gradient;
                },
                order: 1,
            },
            {
                type: "line",
                label: "AI Forecast",
                data: aiPredictedData,
                borderColor: "#f59e0b",
                borderWidth: 2,
                borderDash: [6, 4],
                pointRadius: 10,
                pointBackgroundColor: "#f59e0b",
                pointBorderColor: "#ffffff",
                pointBorderWidth: 2.5,
                pointStyle: 'circle',
                pointHoverRadius: 13,
                fill: false,
                order: 0,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            duration: 1400,
            easing: 'easeInOutCubic',
            delay: (ctx) => ctx.type === 'data' ? ctx.dataIndex * 80 : 0,
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: "rgba(15,23,42,0.9)",
                titleColor: "rgba(255,255,255,0.9)",
                bodyColor: "rgba(148,163,184,0.9)",
                borderColor: "rgba(255,255,255,0.08)",
                borderWidth: 1,
                padding: 12,
                cornerRadius: 8,
                callbacks: { label: (ctx) => `  ${ctx.parsed.y ?? '—'} pts` },
            },
        },
        scales: {
            x: {
                ticks: { color: "#94a3b8", font: { size: 11 } },
                grid: { display: false },
                border: { display: false },
            },
            y: {
                ticks: { color: "#94a3b8", font: { size: 11 }, maxTicksLimit: 5 },
                grid: { color: "rgba(241,245,249,1)", drawBorder: false },
                border: { display: false },
                min: 0, max: 1600,
            },
        },
        layout: { padding: { top: 24, bottom: 0, left: 0, right: 0 } },
        elements: { line: { tension: 0.4 }, bar: { borderSkipped: false } },
    };

    const handleNavigatequiz = async (parsedData, quiz_type, testname) => {
        localStorage.setItem("currentTest", parsedData);
        localStorage.setItem("type", quiz_type);
        localStorage.setItem("testname", testname);
        localStorage.setItem("hw", false);
        localStorage.setItem("diagnostic", true);

        navigate("/sat/quiz");
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="h-full"
            style={{ background: "#eef2f7" }}
        >
            {/* Modals */}
            {infoMessage && (
                <div className="fixed inset-0 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm z-50" onClick={() => setInfoMessage("")}>
                    <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-6 w-80" onClick={(e) => e.stopPropagation()}>
                        <p className="text-slate-700 text-center">{infoMessage}</p>
                        <button onClick={() => setInfoMessage("")} className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-500 mx-auto block transition text-sm font-medium">Close</button>
                    </div>
                </div>
            )}
            <PromotionModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
            <ModalComponent topic={topic} isOpen={isModalOpen2} onClose={setIsModalOpen2} section={section} type={'SAT'} />

            {/* ── Mobile: scrollable ── */}
            <div className="block md:hidden pt-5 pb-6 px-4 flex flex-col gap-3">
                {noTestsTaken && (
                    <div className="flex flex-col gap-2 bg-blue-50 border border-blue-100 p-4 rounded-xl">
                        <p className="font-bold text-slate-800 text-base">No tests taken yet!</p>
                        <button onClick={() => handleNavigatequiz('8f88e495-7699-45d6-b3f9-e00c0807ea68', 'SAT', 'English First Test')}
                            className="bg-blue-600 text-white text-sm font-semibold py-2 px-4 rounded-lg">English Diagnostic</button>
                        <button onClick={() => handleNavigatequiz('a6cd0914-998b-4fae-aaa4-2adf823a0ec6', 'SAT', 'Math First Test')}
                            className="bg-violet-600 text-white text-sm font-semibold py-2 px-4 rounded-lg">Math Diagnostic</button>
                    </div>
                )}
                <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-4 text-center">
                    <p className="text-xs text-slate-400 uppercase tracking-wider mb-1">Latest SAT Score</p>
                    <p className="text-4xl font-black text-blue-600">{lastTest ? <CountUp start={0} end={lastTest} duration={1.5} separator="," /> : '???'}<span className="text-lg text-slate-400 font-normal ml-1">/ 1600</span></p>
                    <div className="grid grid-cols-2 gap-2 mt-3">
                        <div className="bg-slate-50 rounded-lg p-3"><p className="text-[10px] text-slate-400">R&W</p><p className="text-xl font-bold text-slate-800">{laste || '???'}</p></div>
                        <div className="bg-slate-50 rounded-lg p-3"><p className="text-[10px] text-slate-400">Math</p><p className="text-xl font-bold text-slate-800">{lastm || '???'}</p></div>
                    </div>
                </div>
                <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-4">
                    <div className="flex items-center gap-2 mb-3">
                        <span className="text-[10px] font-bold text-blue-600 bg-blue-50 border border-blue-200 px-2 py-0.5 rounded-full">✦ AI Predicted</span>
                        <span className="text-sm font-bold text-slate-700">Progress History</span>
                    </div>
                    <Bar data={data} options={options} plugins={[aiLabelPlugin]} />
                </div>
                <MissingTopics setdashboard={setdashboard} user={user} topEngTopics={topEngTopics} topMathTopics={topMathTopics} handleRowClick={handleRowClick} setInfoMessage={setInfoMessage} />
                <OverallSATAnal setInfoMessage={setInfoMessage} />
            </div>

            {/* ── PC: full height, no scroll ── */}
            <div className="hidden md:flex flex-col h-full">

                {/* Top banner (only when no tests) */}
                {noTestsTaken && (
                    <div className="flex items-center justify-between bg-blue-50 border-b border-blue-100 px-6 py-3 shrink-0 gap-4">
                        <p className="font-bold text-slate-800 text-sm">Looks like you haven't taken any test yet! Try a diagnostic below.</p>
                        <div className="flex gap-2">
                            <button onClick={() => handleNavigatequiz('8f88e495-7699-45d6-b3f9-e00c0807ea68', 'SAT', 'English First Test')}
                                className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition">
                                <BookOpen size={13} /> English Diagnostic
                            </button>
                            <button onClick={() => handleNavigatequiz('a6cd0914-998b-4fae-aaa4-2adf823a0ec6', 'SAT', 'Math First Test')}
                                className="flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition">
                                <Calculator size={13} /> Math Diagnostic
                            </button>
                        </div>
                    </div>
                )}

                {/* Page header */}
                <div className="px-6 py-3 flex items-center gap-3 shrink-0 border-b border-slate-200/60">
                    <h1 className="text-xl font-bold text-slate-900">Digital SAT</h1>
                    <div className="flex-1 h-px bg-slate-200" />
                </div>

                {/* Main grid — fills remaining height exactly */}
                <div className="flex-1 min-h-0 flex gap-3 px-14 py-4">

                    {/* Left column */}
                    <div className="flex flex-col gap-2.5 w-[34%] shrink-0 min-h-0">

                        {/* Score card */}
                        <div className="bg-white border border-slate-200 rounded-xl shadow-sm px-5 py-4 shrink-0">
                            <p className="text-center text-xs font-bold text-slate-400 uppercase tracking-[0.18em] mb-3">Latest SAT Score</p>
                            <div className="flex justify-center items-baseline gap-2 mb-4">
                                <span className="text-6xl font-black text-blue-600">
                                    {lastTest ? <CountUp start={0} end={lastTest} duration={1.5} separator="," /> : '???'}
                                </span>
                                <span className="text-xl text-slate-400">/ 1600</span>
                            </div>
                            <div className="grid grid-cols-2 gap-2.5">
                                <div className="bg-[#f8fafc] border border-slate-100 rounded-lg p-3 text-center">
                                    <p className="text-slate-400 text-xs mb-1.5">Reading & Writing</p>
                                    <div className="flex items-center justify-center gap-1.5">
                                        <span className="text-2xl font-bold text-slate-800">{laste ? <CountUp start={0} end={laste} duration={1.5} separator="," /> : '???'}</span>
                                        <span className={`text-xs font-semibold ${getPerformanceLabel(laste).glowColor === 'redGlow' ? 'text-red-500' : getPerformanceLabel(laste).glowColor === 'orangeGlow' ? 'text-orange-500' : 'text-emerald-500'}`}>{getPerformanceLabel(laste).label}</span>
                                    </div>
                                </div>
                                <div className="bg-[#f8fafc] border border-slate-100 rounded-lg p-3 text-center">
                                    <p className="text-slate-400 text-xs mb-1.5">Math</p>
                                    <div className="flex items-center justify-center gap-1.5">
                                        <span className="text-2xl font-bold text-slate-800">{lastm ? <CountUp start={0} end={lastm} duration={1.5} separator="," /> : '???'}</span>
                                        <span className={`text-xs font-semibold ${getPerformanceLabel(lastm).glowColor === 'redGlow' ? 'text-red-500' : getPerformanceLabel(lastm).glowColor === 'orangeGlow' ? 'text-orange-500' : 'text-emerald-500'}`}>{getPerformanceLabel(lastm).label}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Mock SAT grid */}
                        <div className="bg-white border border-slate-200 rounded-xl shadow-sm px-3 py-2.5 shrink-0">
                            <p className="text-sm font-bold text-slate-600 mb-2 uppercase tracking-widest">Mock SAT Tests</p>
                            <div className="grid grid-cols-3 gap-1.5">
                                {scores.map((item, index) => (
                                    <div key={index}
                                        className="bg-[#f8fafc] border border-slate-100 rounded-lg py-2 px-1 text-center cursor-pointer hover:border-blue-300 hover:bg-blue-50 transition-all duration-150"
                                        onClick={() => setdashboard(3)}>
                                        <p className="text-[9px] text-slate-400 mb-0.5 leading-tight">Mock {item.name}</p>
                                        <p className="text-base font-bold text-blue-600">{(item.myScore === 0 || item.myScore === "0") ? "???" : item.myScore}</p>
                                        <p className="text-[9px] text-slate-400">avg {item.avgScore}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Progress history */}
                        <div className="bg-white border border-slate-200 rounded-xl shadow-sm flex-1 min-h-0 flex flex-col overflow-hidden">
                            {/* Top gradient stripe */}
                            <div className="h-[3px] shrink-0" style={{ background: "linear-gradient(90deg, #2563eb 0%, #7c3aed 50%, #0ea5e9 100%)" }} />
                            {/* Header */}
                            <div className="flex items-center justify-between px-4 pt-3 pb-1 shrink-0">
                                <span className="text-[11px] font-bold text-slate-500 uppercase tracking-[0.15em]">Progress History</span>
                                <div className="flex items-center gap-3 text-[11px] text-slate-400">
                                    <span className="flex items-center gap-1.5">
                                        <span className="inline-block w-3 h-[2px] rounded bg-blue-500" />
                                        Trend
                                    </span>
                                    <span className="flex items-center gap-1.5">
                                        <span className="inline-block w-2 h-2 rounded-full bg-amber-400" />
                                        AI Forecast
                                    </span>
                                </div>
                            </div>
                            {/* Chart */}
                            <div className="flex-1 min-h-0 px-3 pb-3">
                                <Bar data={data} options={options} plugins={[aiLabelPlugin]} />
                            </div>
                        </div>
                    </div>

                    {/* Right column */}
                    <div className="flex gap-2.5 flex-1 min-w-0 min-h-0">
                        <div className="flex-1 min-w-0 min-h-0">
                            <MissingTopics setdashboard={setdashboard} user={user} topEngTopics={topEngTopics} topMathTopics={topMathTopics} handleRowClick={handleRowClick} setInfoMessage={setInfoMessage} />
                        </div>
                        <div className="flex-1 min-w-0 min-h-0">
                            <OverallSATAnal setInfoMessage={setInfoMessage} />
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default DigitalSatView;
